import { FC, PropsWithChildren } from "react";
import { Box } from "@mui/material";

type Props = PropsWithChildren;

export const Content: FC<Props> = ({ children }) => {
  return (
    <Box
      className="ma-content"
      sx={{
        flex: 1,
        position: "relative",
        height: "100%",
        // Dark mode puts cards on the page colour rather than the card colour, or they blend in.
        backgroundColor: (t) =>
          t.palette.mode === "dark"
            ? t.palette.background.default
            : t.palette.background.paper
      }}
    >
      {children}
    </Box>
  );
};
